import styled from '@emotion/styled';
import { rem } from '@triumph/design-system';
import { useState } from 'react';

const StyledButton = styled.button`
    font-size: ${rem(11)};
    font-weight: ${({ theme }) => theme.typography.fontWeights.regular};
    line-height: 1;
    padding: ${rem(2)} ${rem(6)};
    border: 1px solid ${({ theme }) => theme.colors.greyscale.gray40};
    border-radius: ${rem(4)};
    background: transparent;
    color: ${({ theme }) => theme.colors.greyscale.gray30};
    cursor: pointer;
    white-space: nowrap;

    &:disabled {
        opacity: 0.5;
        cursor: default;
    }

    &:hover:not(:disabled) {
        background: ${({ theme }) => theme.colors.greyscale.gray10};
    }
`;

interface CopyOrpLinkButtonProps {
    label: string;
    preText?: string;
    'data-testid'?: string;
}

export const CopyOrpLinkButton = ({
    label,
    preText,
    'data-testid': testId,
}: CopyOrpLinkButtonProps) => {
    const isIframed = window.self !== window.top;
    const [isOrpLinkCopied, setIsOrpLinkCopied] = useState(false);

    const handleCopyActiveOrpLink = () => {
        navigator.clipboard.writeText(window.location.href);
        setIsOrpLinkCopied(true);
        setTimeout(() => setIsOrpLinkCopied(false), 2000);
    };

    return (
        <>
            {preText ? `${preText} ` : ''}
            {isIframed ? (
                window.location.href
            ) : (
                <StyledButton
                    onClick={handleCopyActiveOrpLink}
                    disabled={isOrpLinkCopied}
                    data-testid={testId}
                >
                    {isOrpLinkCopied ? 'Link Copied to Clipboard' : label}
                </StyledButton>
            )}
        </>
    );
};
